import React, { useState, useEffect } from 'react'
import {
    Form,
    Card,
    Modal,
    Button,
    Input,
    Radio,
    Divider,
    Switch,
    Table,
    message
} from 'antd'
import RowLayout from '../../../commons/RowLayout/RowLayout'
import IconSelector from './../../../commons/IconSelector/IconSelector'

const TopbarMenuModal = ({ T, isOpen, onCancel, onOk, info = {} }) => {
    let [icon, setIcon] = useState(info.icon)

    const [form] = Form.useForm()

    useEffect(() => {
        if (isOpen) {
            console.log(info)
            setIcon(info.icon)
            form.setFieldsValue({
                title: info.title,
                url: info.url,
                isNewTab: info.is_new_tab
            })
        }
    }, [isOpen])

    function onFinish(values) {
        let data = {
            icon,
            title: values.title,
            url: values.url,
            is_new_tab: values.isNewTab
        }
        onOk(data)
    }

    function onChangeIcon(icon) {
        setIcon(icon)
    }

    return (
        <Modal
            form={form}
            width={640}
            title={T('TOPBAR_MENU')}
            visible={isOpen}
            centered
            okText={T('SAVE')}
            cancelText={T('CANCEL')}
            onOk={() => {
                form.validateFields()
                    .then(values => {
                        form.resetFields()
                        onFinish(values)
                    })
                    .catch(err => {
                        console.log('Validate Failed:', err)
                    })
            }}
            onCancel={() => onCancel()}>
            <Form form={form}>
                <RowLayout title={T('ICON')} contentSpan={16}>
                    <IconSelector
                        T={T}
                        selectedIcon={icon}
                        onSelect={onChangeIcon.bind(this)}
                    />
                </RowLayout>
                <RowLayout title={T('TEXT')} contentSpan={16}>
                    <Form.Item name="title">
                        <Input placeholder={T('TEXT')} />
                    </Form.Item>
                </RowLayout>
                <RowLayout title={T('URL')} contentSpan={16}>
                    <Form.Item name="url">
                        <Input placeholder={'e.g. https://www.indytheme.com'} />
                    </Form.Item>
                </RowLayout>
                <RowLayout title={T('OPEN_NEW_TAB')} contentSpan={16}>
                    <Form.Item name="isNewTab" valuePropName="checked">
                        <Switch />
                    </Form.Item>
                </RowLayout>
            </Form>
        </Modal>
    )
}

export default TopbarMenuModal
